import { z } from 'zod';
import { publicUserSchema } from './user.js';
/**
 * Csatorna-canvas: kozosen szerkesztett dokumentum a csatorna fontos infoival.
 *
 * A tartalom NEM ezen a sematon jon at. A dokumentumot a Yjs (CRDT) allapota
 * hordozza, ami nyers bajtsorozat, es sajat WebSocket-en (`/ws/canvas`) megy -
 * lasd `packages/shared/src/canvas.ts` alján a protokoll-leirast. Ez a sema
 * csak a canvas *adatlapja*: cim, ki mikor nyult hozza, mekkora.
 *
 * Igy a lista lekerdezese olcso marad: nem kell hozza dokumentumot betolteni.
 */
export const canvasSchema = z.object({
    id: z.string(),
    channelId: z.string(),
    title: z.string(),
    /** KIEMELT canvas - akarhany lehet; a lista elejen allnak. */
    isPrimary: z.boolean(),
    /** A csatorna kozos sorrendje (huzassal allithato) - a kiemelteken, illetve a tobbin belul. */
    sortOrder: z.number().default(0),
    /** Elonezet a listahoz: a dokumentum elso par sora, sima szoveggel. */
    preview: z.string(),
    createdBy: publicUserSchema.nullable(),
    updatedBy: publicUserSchema.nullable(),
    createdAt: z.string(),
    updatedAt: z.string(),
    /** Hivas-jegyzet (H4): a hivas, amihez keszult. */
    huddleId: z.string().nullable().default(null),
    /** Hany helyre osztotta meg a tulajdonos (szemelyes canvas) - a tulajdonos listajan latszik. */
    shareCount: z.number().default(0),
    /**
     * MASHONNAN megosztva jelenik meg ebben a listaban (nem e csatorna sajatja).
     * Ilyenkor a kiemeles, a sorrend es a torles a tulajdonose, itt nem allithato.
     */
    viaShare: z.boolean().default(false),
});
/**
 * SZEMELYES canvas megosztasa: kivel/hova.
 *
 *  - `user`:    a cimzett "Saját jegyzetek" panelen, a "Velem megosztva" alatt;
 *  - `group`:   a csoport minden tagjanal ugyanigy;
 *  - `channel`: a csatorna canvasai kozott.
 * Mindegyik cel szerkesztheti is.
 */
export const canvasShareKindSchema = z.enum(['user', 'channel', 'group']);
export const canvasShareSchema = z.object({
    id: z.string(),
    kind: canvasShareKindSchema,
    targetId: z.string(),
    createdAt: z.string(),
});
export const createCanvasShareSchema = z.object({
    kind: canvasShareKindSchema,
    targetId: z.string().min(1),
});
/** Ennyi karakter kerul a listan lathato elonezetbe. */
export const CANVAS_PREVIEW_LENGTH = 160;
/**
 * A cim felso hatara.
 *
 * Nem tartalmi korlat, hanem felulet-vedelem: a canvas-lista egy keskeny
 * panelben el, es egy 2000 karakteres cim hasznalhatatlanna tenne.
 */
export const MAX_CANVAS_TITLE_LENGTH = 120;
export const canvasTitleSchema = z
    .string()
    .trim()
    .min(1, 'A cim nem lehet ures.')
    .max(MAX_CANVAS_TITLE_LENGTH, `A cím legfeljebb ${MAX_CANVAS_TITLE_LENGTH} karakter lehet.`);
/**
 * A dokumentum felso hatara sima szovegben merve.
 *
 * A Yjs allapot csak nő: minden leutes hozzaad, a torles is bejegyzes. Korlat
 * nelkul egyetlen canvas evek alatt tobb szaz megabajtra hizna, es minden
 * megnyitasnal at kellene kuldeni. A hatart a szerver a mentesnel ellenorzi.
 */
export const MAX_CANVAS_TEXT_LENGTH = 200_000;
export const createCanvasSchema = z.object({
    title: canvasTitleSchema,
    /** Az elso canvas magatol kiemelt lesz; ezt a hivo felulirhatja. */
    isPrimary: z.boolean().optional(),
});
export const updateCanvasSchema = z.object({
    title: canvasTitleSchema.optional(),
    isPrimary: z.boolean().optional(),
});
/** A csatorna canvasainak uj sorrendje (huzas utan) - az azonositok a kivant sorrendben. */
export const reorderCanvasesSchema = z.object({
    canvasIds: z.array(z.string()).min(1).max(500),
});
/**
 * ── A canvas-WebSocket protokollja ───────────────────────────────────────────
 *
 * A `/ws/canvas?canvasId=...` vegpont BINARIS kereteket valt, nem JSON-t: a
 * Yjs frissitesei nyers bajtok, es base64-be csomagolva harmadaval tobbet
 * kellene atkuldeni minden leutesnel.
 *
 * Minden keret elso bajtja a tipus, a maradek a hasznos teher:
 *
 *   0 SYNC      y-protocols/sync uzenet (allapot-csere es frissitesek)
 *   1 AWARENESS y-protocols/awareness uzenet (kurzorok, nevek, szinek)
 *
 * A szerver nem ertelmezi a dokumentumot: alkalmazza a frissitest a sajat
 * peldanyara, tovabbadja a tobbieknek, es idonkent elmenti. A jelenlet
 * (awareness) NEM megy adatbazisba - az kapcsolat-elettartamu.
 */
export const CANVAS_FRAME_SYNC = 0;
export const CANVAS_FRAME_AWARENESS = 1;
/**
 * Ennyi tetlenseg utan mentunk az adatbazisba.
 *
 * Nem minden leutesnel irunk: gepeles kozben ez masodpercenkent tobb tucat
 * irast jelentene. A frissitesek addig is minden kliensnel ott vannak, tehat
 * a kesleltetes csak a tartos tarolast erinti.
 */
export const CANVAS_SAVE_DEBOUNCE_MS = 2_000;
/**
 * Ennyi ido utan MINDENKEPP mentunk, akkor is, ha folyamatosan gepelnek.
 *
 * A puszta kesleltetes egy hosszu, megszakitas nelkuli gepelesnel sosem sulne
 * el - egy szerver-ujrainditas ilyenkor az egesz munkat elvinne.
 */
export const CANVAS_SAVE_MAX_WAIT_MS = 15_000;
//# sourceMappingURL=canvas.js.map